import { StreamData } from 'types/streamData'
import WidgetType from 'enums/WidgetType'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const negSentimentResolver: FieldResolver = (metadata: Metadata) => {
  const widgetType = metadata.getWidgetType()
  let negSentiment
  if (widgetType && widgetType === WidgetType.SOCIAL_WEB_POPULAR_POSTS) {
    negSentiment = metadata.getNegSentiment()
  }

  return { negSentiment } as StreamData
}

export default negSentimentResolver
